import { type IAnnouncementsQuery } from 'application/querySchemas/IAnnouncementsQuery';
import { type IAnnouncementsClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAnnouncementsClient';
import { type IAnnouncementTargetType } from 'domain/entities/Announcement/Announcement';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AnnouncementsQuery implements IAnnouncementsQuery {
    constructor(
        @inject('IAnnouncementsClient')
        public readonly announcementsClient: IAnnouncementsClient,
    ) {}

    async fetch(params?: {
        offset?: number;
        limit?: number;
        targetType?: IAnnouncementTargetType;
    }): Promise<IGetResponse['data']> {
        const response = await this.announcementsClient.get({
            offset: params?.offset,
            limit: params?.limit,
            target_type: params?.targetType,
        });
        return response.data;
    }
}
